/*@ngInject*/
const UploadAttachmentController = function ($rootScope, $scope, $controller, $window, xmlUtil, attachmentMediator, uuidUtil, localization, modalUtil, attachmentUtil, coreConstant, loadingBarHandler, preferenceModel) {

    let translations;

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    localization.getTranslationByKey('uploadAttachment').then((result) => {
        translations = result;
    });

    this.$onInit = function () {
        this.onInit();

        let uiField = this.fieldStructure.uiField,
            uiFieldOptions,
            imageProperty,
            splitParameters;

        this.attachmentType = xmlUtil.parseString(uiField.options).attachmentType;
        this.label = this.fieldStructure.uiField.displayLabel;
        this.fieldStructure.requiredIndicatorLabelConfig.label = null;
        this.parameters = xmlUtil.parseString(uiField.options).parameters;
        this.acceptedTypes = null;
        this.globalAcceptedTypes = preferenceModel.get('system.allowedFileTypes').split('::');
        this.fileInputAcceptTypes = '';

        this.buildImageProperty();

        if (this.parameters) {
            splitParameters = _.split(this.parameters, 'fileType=', 2);
            this.fileInputAcceptTypes = splitParameters[1];
            if (splitParameters.length > 1) {
                this.acceptedTypes = _.split(splitParameters[1], ',');
            }
        }
    };

    this.getButtonWidth = function() {
        const inputContainerWidth = 160;
        let isRowRepeater = this.fieldStructure.isRowRepeaterField;
        if(isRowRepeater && this.fieldStructure.layout.labelWidth === 0) {
            return inputContainerWidth;
        } else {
            return this.fieldStructure.layout.labelWidth;
        }
    };

    this.buildImageProperty = function () {
        let uiField = this.fieldStructure.uiField,
            uiFieldOptions = xmlUtil.parseString(uiField.options),
            imageProperty = uiFieldOptions.imageProperty;
        this.isImageUrlLoaded = false;
        this.isImage = imageProperty ? imageProperty.isImageDisplayChecked : false;
        if (this.isImage) {
            this.imageWidth = imageProperty ? parseInt(imageProperty.imageWidth) : 0;
            this.imageHeight = imageProperty ? parseInt(imageProperty.imageHeight) : 0;
            this.imageUrl = null;
            this.buildImageUrl();
        }
    }

    this.buildImageUrl = function () {
        attachmentUtil.getAttachmentLinkURL(this.getAttachmentId(), this.getAttachmentName()).then((url) => {
            this.imageUrl = url;
            this.isImageUrlLoaded = true;
        });
    };

    this.$onChanges = function () {
        this.onChanges();
        this.fieldStructure.requiredIndicatorLabelConfig.label = null;
    };

    this.fileSelected = function (file, event) {
        let submissionId = this.fieldStructure.parentForm.submissionId,
            allowFile = attachmentUtil.validateAttachmentType(file, _.get(translations, 'unacceptableType'), this.acceptedTypes, this.globalAcceptedTypes),
            queryParameters;

        if (allowFile) {
            queryParameters = {
                'type': this.attachmentType,
                'description': '',
                'fileExpectedSize': file.size,
                'guid': uuidUtil.generateUUID(),
                'name': file.name,
                'formId': this.fieldStructure.parentForm.id,
                'fieldName': this.fieldStructure.indexedName
            };

            if (submissionId) {
                queryParameters.submissionId = submissionId;
            }

            loadingBarHandler.showLoadingBar('formsViewer.controls.uploadAttachment.loadingBar');

            attachmentMediator.saveAttachment(queryParameters, file).then((payload) => {
                loadingBarHandler.hideLoadingBar();
                let attachmentId = payload.attachment.id;
                if (!this.fieldStructure.fieldModel) {
                    this.fieldStructure.fieldModel = {};
                }
                this.fieldStructure.fieldModel.value = file.name + '|' + attachmentId;
                this.fieldStructure.hasLocalChanges = true;
                this.updateFieldValue();
                this.buildImageProperty();
            });
        } else {
            event.target.value = null;
        }
    };

    this.deleteAttachment = function () {
        let message = _.get(translations, 'deleteConfirmation.message'),
            title = _.get(translations, 'deleteConfirmation.title'),
            cancelButtonLabel = _.get(translations, 'deleteConfirmation.cancel'),
            confirmButtonLabel = _.get(translations, 'deleteConfirmation.confirm'),
            fieldInstance = this.fieldStructure.fieldModel,
            attachmentId = this.getAttachmentId();

        function handleClose() {
            attachmentMediator.deleteAttachment(attachmentId, fieldInstance.id).then(() => {
                this.isImageUrlLoaded = false;
            });
        }

        modalUtil.showGenericConfirm({
            cancelButtonLabel: cancelButtonLabel,
            confirmActionButtonLabel: confirmButtonLabel,
            summary: message,
            title: title
        }).then(handleClose);
    };

    this.getAttachmentId = function () {
        if (this.fieldStructure.fieldModel.value) {
            let fieldValue = this.fieldStructure.fieldModel.value;
            return fieldValue.substring(_.lastIndexOf(fieldValue, '|') + 1);
        }
    };

    this.getAttachmentName = function () {
        if (this.fieldStructure.fieldModel.value) {
            let fieldValue = this.fieldStructure.fieldModel.value;
            return fieldValue.substring(0, _.lastIndexOf(fieldValue, '|'));
        }
    };

    this.getLinkText = function () {
        if (this.fieldStructure.fieldModel.value) {
            return this.getAttachmentName();
        }
        return '';
    };

    $scope.attachmentDownloadClick = ($event) => {
        $event.stopPropagation();
        attachmentUtil.getAttachmentLinkURL(this.getAttachmentId(), this.getAttachmentName()).then((url) => {
            $window.open(url, '_blank');
        });
    }
};

angular.module('umFormViewer')
    .controller('uploadAttachmentController', UploadAttachmentController);
